import { faFilter, faSearch } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import axios from "axios";
import React, { useEffect, useState } from "react";
import { Card, Col, Form, InputGroup, Row } from "react-bootstrap";
import { useNavigate, useParams } from "react-router-dom";
import { getCookie } from "typescript-cookie";

interface CampaignData {
  qr_code_path?: any;
}

const CampaignView = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const Organization_Id = getCookie("organizationId");
  const Token = getCookie("authToken");
  const [searchTerm, setSearchTerm] = useState("");
  const [visitors, setVisitors] = useState<any[]>([]);
  const [campaignData, setCampaignData] = useState<CampaignData>({});

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    fetchVisitors();
    fetchQrcode();
    // eslint-disable-next-line
  }, []);

  const fetchVisitors = async () => {
    if (Organization_Id && Token && id) {
      try {
        const apiUrl = `${process.env.REACT_APP_API_URL}api/campaign/${id}/visitors?organization_id=${Organization_Id}&is_productLikes=true`;
        const response = await axios.get(apiUrl, {
          headers: {
            Authorization: `Bearer ${Token}`,
          },
        });
        const visitorData = response.data.data || [];
        setVisitors(visitorData);
      } catch (error) {
        console.error("Error fetching visitors:", error);
      }
    }
  };

  const sortedVisitors = visitors.sort(
    (a: any, b: any) => b.isActive - a.isActive
  );

  const filteredVisitors = sortedVisitors.filter(
    (visitor) =>
      (visitor.mobile_number &&
        visitor.mobile_number.toString().includes(searchTerm)) ||
      (visitor.email && visitor.email.includes(searchTerm))
  );

  const fetchQrcode = async () => {
    if (Organization_Id && Token && id) {
      try {
        const apiUrl = `${process.env.REACT_APP_API_URL}api/campaigns/${id}?organization_id=${Organization_Id}`;
        const response = await axios.get(apiUrl, {
          headers: {
            Authorization: `Bearer ${Token}`,
          },
        });
        setCampaignData(response.data.data);
        console.log(response.data.data, "response.data.data");
      } catch (error) {
        console.error("Error fetching qrcode:", error);
      }
    }
  };

  const staticimage = "/images/demo_qr_code.png";
  return (
    <div className="kiosk-container mt-4 overflow-hidden">
      <Row className="align-items-center mb-3">
        <Col xs={12} md={6}>
          <h2 className="fw-bold mb-2 mb-md-0 theme-color-kiosk-title">Campaign 1</h2>
        </Col>
        <Col
          xs={12}
          md={6}
          className="d-flex justify-content-end align-items-start gap-2 flex-column flex-md-row"
        >
          <button className="custom-load-more-btn p-3 px-4">
            Enable Kiosk Mode
          </button>
        </Col>
      </Row>
      <Row className="mt-3">
        <Col xs={12} md={8} className="mb-3 mb-md-0 d-flex align-items-stretch">
          <div className="rounded w-100">
            <img
              src="/images/campaign_view_banner.jpg"
              className="rounded img-fluid h-100"
              style={{ objectFit: "cover" }}
              alt=""
            />
          </div>
        </Col>
        <Col xs={12} md={4} className="d-flex align-items-stretch">
          <div className="rounded text-center w-100 p-3 d-flex flex-column justify-content-center align-items-center qr-box">
            <img
              src={
                campaignData.qr_code_path
                  ? campaignData.qr_code_path
                  : staticimage
              }
              className="mt-5 img-fluid theme-color"
              style={{ maxHeight: "100%", width: "auto", maxWidth: "75%" }}
              alt="QR Code"
            />
            <div className="d-flex justify-content-center align-items-center mt-4">
              <img src="/icon/qr_icon.svg" alt="" />
              <p className="mb-0 mx-2" style={{ color: "#8B8C8D" }}>Scan this QR code to get started</p>
            </div>
          </div>
        </Col>
      </Row>

      <Row className="align-items-center mt-5 mb-4">
        <Col>
          <h2 className="fw-bold theme-color-kiosk-title">Visitor List</h2>
        </Col>
        <Col className="d-flex justify-content-end align-items-center">
          <InputGroup className="me-2 input-search-field" style={{ borderRadius: "8.5px", border: "0.5px solid #8B8C8D" }}>
            <InputGroup.Text className="uniform-back-btn border-0 custom-search-icon">
              <FontAwesomeIcon
                icon={faSearch}
                style={{
                  color: "white",
                  height: "18.04px",
                  width: "18.04px",
                }}
              />
            </InputGroup.Text>
            <Form.Control
              type="text"
              placeholder="Search Visitor"
              aria-label="Search Visitor"
              className="custom-search-kiosk"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />

          </InputGroup>
          <button className="btn btn-icon uniform-back-btn">
            <FontAwesomeIcon
              icon={faFilter}
              style={{
                color: "white",
                height: "18.04px",
                width: "18.04px",
              }}
            />
          </button>
        </Col>
      </Row>
      <Row className="mb-3" style={{ borderBottom: "1px solid #8B8C8D80", borderTop: "1px solid #8B8C8D80" }}>
        <Col className="d-flex justify-content-center align-items-center theme-color py-3">
          Email Id
        </Col>
        <Col className="d-flex justify-content-center align-items-center theme-color py-3">
          Mobile Number
        </Col>
        <Col className="d-flex justify-content-center align-items-center theme-color py-3">
          Status
        </Col>
        <Col className="d-flex justify-content-center align-items-center theme-color py-3">
          Selected Product
        </Col>
      </Row>
      <Row>
        {filteredVisitors.map((visitor, index) => (
          <Col xs={12} key={index} className="my-3">
            <Card
              className="campaign-list-card px-0 py-3"
              onClick={() => navigate(`${visitor.id}/visitor-details`)}
            >
              <Card.Body className="py-3 px-0">
                <Card.Text className="row m-0 fs-4 d-flex justify-content-center align-items-center flex-wrap">
                  <div className="col d-flex justify-content-center align-items-center">
                    <b className="text-start theme-color-kiosk-title">
                      {visitor.email || ""}
                    </b>
                  </div>
                  <div className="col d-flex justify-content-center align-items-center">
                    <b className="text-start theme-color">
                      {visitor.mobile_number || ""}
                    </b>
                  </div>
                  <div className="col d-flex justify-content-center align-items-center">
                    <span
                      className={`badge rounded-0 px-4 py-2 ${visitor.is_blocked === 0 ? "badge-green" : "badge-red"}`}
                    >
                      {visitor.is_blocked === 0 ? "Active" : "Inactive"}
                    </span>
                  </div>
                  <div className="col d-flex justify-content-center align-items-center">
                    <button className="btn btn-sm uniform-blue-btn width-for-fvt-product-btn">
                      Favorite Products : {visitor.totalProductLikes}
                    </button>
                  </div>
                </Card.Text>
              </Card.Body>
            </Card>
          </Col>
        ))}
      </Row>
      {/* <div className="d-flex justify-content-center mt-4 mb-5">
        <button className="btn btn-sm uniform-submit-btn">Load More</button>
      </div> */}
    </div>
  );
};

export default CampaignView;
